import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ContactForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t("contact.errorRequired");
    if (!values.email.trim()) e.email = t("contact.errorRequired");
    else if (!EMAIL_RE.test(values.email)) e.email = t("contact.errorEmail");
    if (!values.message.trim()) e.message = t("contact.errorRequired");
    else if (values.message.trim().length < 15) e.message = t("contact.errorMessage");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (evt) => {
    evt.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    // Frontend-only — simulate short delay then redirect.
    setTimeout(() => {
      setSubmitting(false);
      navigate("/thank_you");
    }, 350);
  };

  const handleChange = (field) => (e) => {
    setValues((v) => ({ ...v, [field]: e.target.value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  return (
    <form className="dma-form" onSubmit={onSubmit} noValidate>
      <div className="dma-form__row">
        <label className="dma-form__label" htmlFor="cf-name">
          {t("contact.nameLabel")}
        </label>
        <input
          id="cf-name"
          type="text"
          className={`dma-form__input ${errors.name ? "has-error" : ""}`}
          placeholder={t("contact.namePlaceholder")}
          value={values.name}
          onChange={handleChange("name")}
          autoComplete="name"
        />
        {errors.name && <span className="dma-form__error">{errors.name}</span>}
      </div>

      <div className="dma-form__row">
        <label className="dma-form__label" htmlFor="cf-email">
          {t("contact.emailLabel")}
        </label>
        <input
          id="cf-email"
          type="email"
          className={`dma-form__input ${errors.email ? "has-error" : ""}`}
          placeholder={t("contact.emailPlaceholder")}
          value={values.email}
          onChange={handleChange("email")}
          autoComplete="email"
        />
        {errors.email && <span className="dma-form__error">{errors.email}</span>}
      </div>

      <div className="dma-form__row">
        <label className="dma-form__label" htmlFor="cf-message">
          {t("contact.messageLabel")}
        </label>
        <textarea
          id="cf-message"
          rows={5}
          className={`dma-form__input dma-form__textarea ${errors.message ? "has-error" : ""}`}
          placeholder={t("contact.messagePlaceholder")}
          value={values.message}
          onChange={handleChange("message")}
        />
        {errors.message && <span className="dma-form__error">{errors.message}</span>}
      </div>

      <p className="dma-form__legal">{t("contact.legal")}</p>

      <button type="submit" className="dma-btn dma-btn--primary dma-form__submit" disabled={submitting}>
        {submitting ? t("contact.sending") : t("contact.submit")}
      </button>
    </form>
  );
}
